
export const setTitle = title => Comp => {
	return class WrapperComp extends Comp {
		constructor() {
			super();
			document.title = title;
		}
		render() {
			return super.render();
		}
	};
};
